module.exports = __webpack_public_path__ + "static/media/ENTRY_NOT_COMPLETED.10390704.svg";